// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3OlUP","image":"Header_image__3LsHT","name":"Header_name__3s1-O","info":"Header_info__1Gr6i","infoRow":"Header_infoRow__R-0JI"};